const coords = {

  cdmx: {
    lat: 19.423780,
    lng: -99.132048
  },

  mty: {
    lat: 25.671712,
    lng: -100.320290
  },

  gdl: {
    lat: 20.672406,
    lng: -103.343143
  }


}



export default coords;



// WEBPACK FOOTER //
// ./src/coords.js